exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#review-content-wrapper[data-v-18fb04ba]{max-width:750px}#review-content-wrapper h1[data-v-18fb04ba]{font-size:30px}#review-content-wrapper input[type=text][data-v-18fb04ba],#review-content-wrapper textarea[data-v-18fb04ba]{border:1px #cecece;background:#f1f1f1;box-shadow:none}", ""]);

// exports
